export const GET_FAULTS = 'get_faults';
export const GET_FAULTS_SUCCESS = 'get_faults_success';
export const GET_FAULTS_FAIL = 'get_faults_fail';
export const GET_FAULT_PHOTOS_AND_VIDEOS = 'get_fault_photos_and_videos';
export const GET_FAULT_PHOTOS_AND_VIDEOS_SUCCESS = 'get_fault_photos_and_videos_success';
export const GET_FAULT_PHOTOS_AND_VIDEOS_FAIL = 'get_fault_photos_and_videos_fail';
export const GET_FAULT_TAGS_DICTIONARY = 'get_fault_tags_dictionary';
export const GET_FAULT_TAGS_DICTIONARY_SUCCESS = 'get_fault_tags_dictionary_success';
export const GET_FAULT_TAGS_DICTIONARY_FAIL = 'get_fault_tags_dictionary_fail';
export const SELECT_FAULT = 'select_fault';
export const SELECT_FAULT_BY_ID = 'select_fault_by_id';
export const START_DRAWING_FAULT = 'start_drawing_fault';
export const FINISH_DRAWING_FAULT = 'finish_drawing_fault';
export const CANCEL_DRAWING_FAULT = 'cancel_drawing_fault';
export const START_DRAWING_FAULT_PHOTO = 'start_drawing_fault_photo';
export const FINISH_DRAWING_FAULT_PHOTO = 'finish_drawing_fault_photo';
export const CANCEL_DRAWING_FAULT_PHOTO = 'cancel_drawing_fault_photo';
export const EDIT_FAULT = 'edit_fault';
export const EDIT_FAULT_SUCCESS = 'edit_fault_success';
export const EDIT_FAULT_FAIL = 'edit_fault_fail';
export const ADD_FAULT = 'add_fault';
export const ADD_FAULT_SUCCESS = 'add_fault_success';
export const ADD_FAULT_FAIL = 'add_fault_fail';
export const DELETE_FAULT = 'delete_fault';
export const DELETE_FAULT_SUCCESS = 'delete_fault_success';
export const DELETE_FAULT_FAIL = 'delete_fault_fail';
export const CLEAR_MESSAGE = 'clear_message'


// WEBPACK FOOTER //
// ./src/types/faults.jsx